// 所有評論區塊
'use client';
import { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { popState } from '@/slices/popSlice';
import { userState } from '@/slices/userSlice';

import NewsCommentComponent from './NewsCommentComponent'; // 一則留言元件
import newsClient from '@/common/apiClient/newsClient';

const NewsCommentWrapper = ({ newsId }) => {
    const { t } = useTranslation();
    const { hintText } = useSelector(popState);
    const { user } = useSelector(userState);

    // 所有留言
    const [comments, setComments] = useState([]);

    // 取得所有留言
    const fetchComments = useCallback(async () => {
        if (!newsId) return;

        try {
            const { comment } = await newsClient.findNewsComment(newsId);
            setComments(comment);
        } catch (e) {
            console.error(e);
        }
    }, [newsId]);

    useEffect(() => {
        fetchComments();
    }, []);

    useEffect(() => {
        if (hintText === 'HINT_COMMENT') fetchComments();
    }, [hintText]);

    useEffect(() => {
        const hash = window.location.hash.substring(1); // 取得 hash，去掉 `#`

        if (!hash) return;

        const observer = new MutationObserver(() => {
            const element = document.getElementById(hash);
            if (element) {
                setTimeout(() => {
                    element.scrollIntoView({ block: 'start' });
                    observer.disconnect(); // 滾動後關閉監聽
                }, 300);
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });

        return () => observer.disconnect();
    }, []);

    if (comments?.length)
        return (
            <div>
                {/* 全部評論 數量 */}
                <p className="text-white text-btn1 pb-[22px]">
                    {t('COMMENTS')}
                    {comments?.length || 0}
                </p>

                {comments?.map((item, i) => (
                    <NewsCommentComponent
                        key={`news-comment-${i}`}
                        info={item}
                        newsId={newsId}
                        user={user}
                    />
                ))}
            </div>
        );

    return null;
};

export default NewsCommentWrapper;
